<template>
  <nav-bar title="创建公司" />
  <Content :bottom="80">
    <van-form class="form" ref="form" @submit="onSubmit">
      <van-field
        v-model="name"
        name="name"
        label="公司名称"
        placeholder="公司名称"
        :rules="[{ required: true, message: '请填写公司名称' }]"
      />
      <van-field
        name="socialCreditCode"
        v-model="socialCreditCode"
        label="企业统一社会信用代码："
        type="text"
        placeholder="企业统一社会信用代码或个体户注册号等"
        :rules="[{ required: true, message: '请填写公司社会信用代码' }]"
      />
      <van-field
        v-model="legalPerson"
        name="legalPerson"
        label="公司法人"
        placeholder="公司法人"
        :rules="[{ required: true, message: '请填写公司法人' }]"
      />
      <van-field
        v-model="version"
        name="version"
        label="排序"
        placeholder="排序"
        :rules="[{ required: true, message: '请填写排序' }]"
      />
      <van-field
        v-model="commodity"
        name="commodity"
        label="商品"
        placeholder="选择商品"
        is-link
        readonly
        :rules="[{ required: true, message: '请选择商品' }]"
        @click="handleCommodityClick"
      />
      <Picker
        label="街道"
        pickerType="cascader"
        @confirm-values="(value) => (streetCode = value)"
      />
      <van-field
        v-model="address"
        name="address"
        label="地址"
        placeholder="地址"
        :rules="[{ required: true, message: '请填写地址' }]"
      />
      <SelectPoint @get-value="selectPoint" />
      <van-field
        name="isTest"
        :rules="[{ required: true, message: '请选择' }]"
        label="是否具备检测资质"
      >
        <template #input>
          <van-radio-group v-model="isTest" direction="horizontal">
            <van-radio name="1">是</van-radio>
            <van-radio name="0">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
    </van-form>
  </Content>
  <div class="fixed-btn">
    <van-button
      block
      type="primary"
      native-type="button"
      :loading="loading"
      :disabled="loading"
      loading-text="请稍后"
      @click="handleSubmitClick"
    >
      确认提交
    </van-button>
  </div>
  <!-- 选择商品 -->
  <commodity-popup
    ref="commodityPopup"
    :commodityList="commodityList"
    @change-checked="onChangeCheked"
  />
</template>

<script>
import { ref, reactive, toRefs, computed } from 'vue'
import { useRouter } from 'vue-router'
import { getGoodsList, addCompany } from '@/api/createCompany'
import { useGetData } from '@/hooks/useGetData'
import { useSubmit } from '@/hooks/useSubmit'
import SelectPoint from './SelectPoint.vue'
import { useStore } from 'vuex'

export default {
  name: 'CreateCompany', // 创建公司
  components: { SelectPoint },
  setup() {
    const store = useStore()
    const operatorId = computed(() => store.state.userInfo.id).value
    // 获取商品列表
    const commodityList = ref([])
    const getCommodityList = useGetData(getGoodsList, (value) => {
      commodityList.value = value
    })
    getCommodityList()
    // 选择商品
    const formData = reactive({
      name: '',
      socialCreditCode: '',
      legalPerson: '',
      version: '',
      commodity: '',
      goodsList: [],
      longitude: 0.0,
      latitude: 0.0,
      streetCode: '',
      address: '',
      tenantId: localStorage.getItem('tenant_id') || '',
      creator: operatorId || '',
      isTest: ''
    })
    const commodityPopup = ref(null)
    const handleCommodityClick = () => {
      // 弹出商品列表
      commodityPopup.value.show = true
    }
    const onChangeCheked = ({ lable, value }) => {
      // 确认选择商品
      formData.commodity = lable.join(',')
      formData.commodityValue = value
      formData.goodsList = value.map((item) => ({ goodsId: item }))
    }
    // 选择位置
    const point = ref('') // 位置
    const selectPoint = (value) => {
      point.value = value
      formData.longitude = value[1]
      formData.latitude = value[0]
    }
    // 提交表单
    const router = useRouter()
    const form = ref(null)
    const handleSubmitClick = () => {
      form.value.submit()
    }
    const { loading, onSubmit } = useSubmit(addCompany, formData, () => {
      router.replace('/companyList')
    })
    const showPicker = ref(false)
    return {
      onSubmit,
      ...toRefs(formData),
      handleSubmitClick,
      form,
      commodityPopup,
      handleCommodityClick,
      onChangeCheked,
      commodityList,
      selectPoint,
      loading,
      showPicker
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  margin-top: 16px;
}
.btn {
  margin: 16px;
}
.fixed-btn {
  position: absolute;
  height: 80px;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  display: flex;
  align-items: center;
}
</style>
